export default __webpack_public_path__ + "static/media/Ico-pending.62bd4fae.svg";